module.exports = __webpack_public_path__ + "static/media/slide3.a0709166.png";